import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { I18nProvider } from '@lingui/react';
import { i18n } from '@lingui/core';
import { router } from '@/lib/router.tsx';
import { setupI18n, setupLocaleInterceptor } from '@/lib/localization.ts';
import { setupAuthInterceptor } from '@/features/auth/interceptors/authInterceptor';
import { setupBuildVersionInterceptor } from '@/features/build-version/interceptors/buildVersionInterceptor';
import { axiosInstance } from '@/lib/api.ts';
import { setProactiveRefreshCallback } from '@/features/auth/tokenStore';
import { AccountService } from '@/features/auth/services/AccountService';

import '@/styles/globals.css';

await setupI18n();
setupAuthInterceptor(axiosInstance);
setupBuildVersionInterceptor(axiosInstance);
setupLocaleInterceptor(axiosInstance);
setProactiveRefreshCallback(() => AccountService.refresh().then(() => undefined));

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nProvider i18n={i18n}>
      <RouterProvider router={router} />
    </I18nProvider>
  </StrictMode>
);
